/**
 * Small "why is this here" chip for intel-suggested options (most-used / diagnosis
 * context). Shared by every EMR picker so the tag looks the same on drugs, diagnoses,
 * complaints, advice, clinical entities, etc. Rendered only in the menu (never on the
 * selected value), and only when an option carries __intelSource.
 */

const INTEL_CHIP_META = {
  'context-doctor': {
    label: '★ You use for this Dx',
    color: '#15803d',
    bg: 'rgba(21, 128, 61, 0.08)',
  },
  'context-global': {
    label: '★ Common for this Dx',
    color: '#15803d',
    bg: 'rgba(21, 128, 61, 0.08)',
  },
  frequent: {
    label: '★ Frequently used',
    color: '#0369a1',
    bg: 'rgba(3, 105, 161, 0.08)',
  },
}

export function IntelSourceChip({ source }) {
  const meta = INTEL_CHIP_META[source]
  if (!meta) {
    return null
  }
  return (
    <span
      style={{
        marginLeft: 6,
        flexShrink: 0,
        fontSize: '10px',
        fontWeight: 700,
        color: meta.color,
        backgroundColor: meta.bg,
        padding: '1px 6px',
        borderRadius: 8,
        whiteSpace: 'nowrap',
        lineHeight: 1.6,
      }}
    >
      {meta.label}
    </span>
  )
}

/**
 * Wraps a picker's rendered label with the intel chip when applicable. `context` is
 * react-select's formatOptionLabel context — the chip is suppressed for the selected
 * value ('value') so it never pollutes the chosen text.
 */
export function withIntelChip(labelNode, option, context) {
  if (context === 'value' || !option?.__intelSource || !INTEL_CHIP_META[option.__intelSource]) {
    return labelNode
  }
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', minWidth: 0, width: '100%' }}>
      <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' }}>{labelNode}</span>
      <IntelSourceChip source={option.__intelSource} />
    </span>
  )
}
